module.exports = __webpack_public_path__ + "static/media/4.b809f62d.png";